import { put, select, takeLatest } from 'redux-saga/effects'
import { BodySurveyConstants } from '../store/bodySurvey.constants'
import { IBodySurveyState } from '../store/bodySurvey.types'
import { getBodySurveySelector } from '../selectors'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import {
  saveBodySurvey,
  setExamPNNVValue,
  setExamValue,
  setFindingsValue,
  setSelectedBodyPart,
  setSelectedBodyPartData,
  updateExamPNNVValue,
  updateExamValue,
} from '../store/bodySurvey.actions'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* deleteDocumentedLocationData() {
  const bodySurvey: IBodySurveyState = yield select(getBodySurveySelector)

  const { examValues, examValuesPNNVs, findings, __deleteBodyLocationFinding } = bodySurvey
  try {
    if (!__deleteBodyLocationFinding) return
    let removeFindings
    let removeExamValues
    let removeExamValuesPnnvs
    if (Array.isArray(__deleteBodyLocationFinding)) {
      removeFindings = findings.filter(
        (finding) => !__deleteBodyLocationFinding.some((deleteFinding) => deleteFinding?.id === finding?.locationId)
      )
      removeExamValues = examValues.filter(
        (finding) => !__deleteBodyLocationFinding.some((deleteFinding) => deleteFinding?.id === finding?.locationId)
      )
      removeExamValuesPnnvs = examValuesPNNVs.filter(
        (finding) => !__deleteBodyLocationFinding.some((deleteFinding) => deleteFinding?.id === finding?.locationId)
      )
    } else {
      removeFindings = findings.filter((finding) => finding.locationId !== __deleteBodyLocationFinding.id)
      removeExamValues = examValues.filter((exam) => exam.locationId !== __deleteBodyLocationFinding.id)
      removeExamValuesPnnvs = examValuesPNNVs.filter((exam) => exam.locationId !== __deleteBodyLocationFinding?.id)
    }

    yield put(setFindingsValue(removeFindings))
    yield put(setExamValue(removeExamValues))
    yield put(setExamPNNVValue(removeExamValuesPnnvs))
    yield put(setSelectedBodyPartData([]))
    yield put(updateExamValue([]))
    yield put(updateExamPNNVValue([]))
    yield put(setSelectedBodyPart(null))
    yield put(saveBodySurvey())
  } catch (e) {
    yield put(throwPcrException(`deleteDocumentedLocationData() error: ${e}`))
  }
}

export function* deleteDocumentedLocationDataSaga() {
  yield takeLatest(
    [BodySurveyConstants.DELETE_BODY_LOCATION_FINDING],
    performWithMutexHOG,
    deleteDocumentedLocationData
  )
}
